import { render, staticRenderFns } from "./ShutterRussianLanguage.vue?vue&type=template&id=66b582a4&lang=pug&"
import script from "./ShutterRussianLanguage.vue?vue&type=script&lang=js&"
export * from "./ShutterRussianLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports